export default __webpack_public_path__ + "static/media/Americano.0b6827cb.png";